"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PriipsPeriod;

(function (PriipsPeriod) {
  PriipsPeriod[PriipsPeriod["Monthly"] = 0] = "Monthly";
  PriipsPeriod[PriipsPeriod["BiMonthly"] = 1] = "BiMonthly";
  PriipsPeriod[PriipsPeriod["Weekly"] = 2] = "Weekly";
  PriipsPeriod[PriipsPeriod["Daily"] = 3] = "Daily";
})(PriipsPeriod = exports.PriipsPeriod || (exports.PriipsPeriod = {}));